(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8075,1368],{

/***/ 92511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65290);





const fallbackImage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=';
const Image = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    const { src, height, objectFit, width, alt, onClick, borderRadius, thumbnail, hover, decoding = 'async', className, lazy = true, pngSrc } = props, others = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(props, ["src", "height", "objectFit", "width", "alt", "onClick", "borderRadius", "thumbnail", "hover", "decoding", "className", "lazy", "pngSrc"]);
    const imgElement = (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, Object.assign({ ref: ref, objectFit: objectFit, src: src || fallbackImage, loading: lazy ? 'lazy' : 'eager', hover: hover, height: height, decoding: decoding, alt: alt }, others)));
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, { height: height, width: width, onClick: onClick, borderRadius: borderRadius, thumbnail: thumbnail, className: className }, pngSrc ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { srcSet: src, type: 'image/webp' }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { srcSet: pngSrc, type: 'image/png' }),
        imgElement)) : (imgElement)));
});
Image.displayName = 'Image';
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ onClick, borderRadius, height, thumbnail, width }) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? 'cursor: pointer;' : ''}
  ${borderRadius ? `border-radius: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(borderRadius)};` : ''}
  ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)};` : ''}
  ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(width)};` : ''}
  ${thumbnail
    ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;`
    : ''}
`);
const StyledImage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .Z.img(({ hover, height, objectFit }) => `
  width: 100%;
  height: ${height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)}` : 'auto'};
  ${objectFit ? `object-fit: ${objectFit}` : ''};
  transition: transform 0.3s;
  &:hover {
    ${hover === 'zoom' ? 'transform: scale(1.05)' : ''};
  };
`);




/***/ }),

/***/ 35760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);



const WrapperImage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .Z.img((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? 'contain' : props.cover ? 'cover' : ''};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === 'zoom' ? 'scale(1.05)' : ''};
  }
  `);
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
    position: 'relative',
    overflow: 'hidden',
    flex: '1 0 auto',
    display: 'flex',
    cursor: props.onClick ? 'pointer' : 'unset',
    zIndex: 0,
    margin: 'auto',
    borderRadius: props.borderRadius + 'px',
    paddingBottom: props.height ? '' : `${100 / props.aspectRatio}%`,
    border: props.border ? '1px solid #e0e0e0' : '',
    height: props.height ? `${props.height}px !important` : '',
    width: props.width ? `${props.width}px` : '100%',
    backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
    backgroundSize: props.thumbnail ? 'cover' : null,
    contentVisibility: props.height && props.width ? 'auto' : null,
}));
const LazyImage = ({ src, onClick, className, contain = false, cover = false, aspectRatio = 1, height, width, alt = '', border = false, hover = '', borderRadius = 0, webp = true, imageWidth, thumbnail, decoding = 'async', }) => {
    const placeHolder = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=';
    let imageUrl = src ? src : placeHolder;
    let altImageUrl = null;
    if (imageUrl && imageUrl.includes('googleusercontent.com')) {
        if (imageWidth) {
            imageUrl = `${imageUrl}=w${imageWidth}`;
        }
        if (webp) {
            const checkExt = /=[a-z0-9-]+$/;
            altImageUrl = imageUrl;
            imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? '-rw' : '=rw'}`;
        }
    }
    const imgError = (image) => {
        image.target.src = placeHolder;
        return;
    };
    const imgEle = (react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, { hover: hover, className: "lazyload", contain: contain, cover: cover, alt: alt, onError: imgError, "data-src": imageUrl, src: imageUrl, loading: "lazy", decoding: decoding }));
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { height: height, width: width, border: border, aspectRatio: aspectRatio, borderRadius: borderRadius, onClick: onClick, className: className, thumbnail: thumbnail }, altImageUrl ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { srcSet: imageUrl, type: 'image/webp' }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { srcSet: altImageUrl, type: 'image/png' }),
        imgEle)) : (imgEle)));
};




/***/ }),

/***/ 1368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61089);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92511);
/* harmony import */ var _helpers_image_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82201);





const EnhancedImage = (props) => {
    const { src, googleImageParams, link, tracking } = props, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(props, ["src", "googleImageParams", "link", "tracking"]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CustomLink */ .x, Object.assign({}, link, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, Object.assign({}, tracking, rest, { src: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getImageUrlFromGoogleUserContent */ .N)(src, Object.assign({ format: 'webp' }, googleImageParams)), pngSrc: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getImageUrlFromGoogleUserContent */ .N)(src, Object.assign({ format: 'png' }, googleImageParams)) }), void 0) }), void 0));
};




/***/ }),

/***/ 82201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ constructGoogleImageParams; },
/* harmony export */   "N": function() { return /* binding */ getImageUrlFromGoogleUserContent; }
/* harmony export */ });
const imgAttributeMapping = {
    width: 'w',
    height: 'h',
    webp: 'rw',
    png: 'rp',
    jpg: 'rj',
    stretch: 's',
    crop: 'c',
};
const constructGoogleImageParams = (url, config) => {
    const baseUrl = url.indexOf('=') >= 0 ? url.substring(0, url.indexOf('=')) : url;
    const params = [];
    Object.entries(config).forEach(([key, value]) => {
        if (!value)
            return;
        if (key === 'format') {
            params.push(imgAttributeMapping[value]);
            return;
        }
        if (key === 'size' && value) {
            params.push(`${imgAttributeMapping[key]}0`);
            return;
        }
        if (imgAttributeMapping[key]) {
            if (typeof value === 'boolean') {
                if (value) {
                    params.push(`${imgAttributeMapping[key]}`);
                    return;
                }
                return;
            }
            params.push(`${imgAttributeMapping[key]}${value}`);
        }
    });
    return params.length > 0 ? `${baseUrl}=${params.join('-')}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
    if (imageUrl && imageUrl.includes('googleusercontent.com'))
        return constructGoogleImageParams(imageUrl, config);
    return imageUrl;
};




/***/ }),

/***/ 175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Gift; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16251);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61089);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35760);




const Text = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)((props) => `
flex: 1;
font-size: 0.75rem;
margin-top: auto;
margin-bottom: auto;
margin-left: 0.5rem;
text-decoration: ${props.disableProductPromo ? 'line-through' : 'none'};
`);
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div `
  display: flex;
  background: #fff;
  cursor: pointer;
`;
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div `
  display: flex;
  align-items: center;
`;
const Gift = (_a) => {
    var { image, text, link, disableProductPromo, cartLineSelected = true, border = true } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["image", "text", "link", "disableProductPromo", "cartLineSelected", "border"]);
    if (link)
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, { href: link },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .LazyImage */ .w, Object.assign({ contain: true, height: 32, width: 32, border: border }, image, { borderRadius: 2 }))),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, { level: 1 }, text),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, { disableProductPromo: disableProductPromo }, text))));
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .LazyImage */ .w, Object.assign({ contain: true, height: 32, width: 32, border: border }, image, { borderRadius: 2 }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, { disableProductPromo: disableProductPromo && cartLineSelected }, text)));
};




/***/ }),

/***/ 63820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ProductInfo; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(61089);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(16251);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/helpers/index.es.js
var helpers_index_es = __webpack_require__(62010);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(1368);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(46161);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/ComboImage/ComboImage.es.js




const IMAGE_LIMIT = 4;
const ComboImage = ({ images, alt = [], keys = [], width, height, childHeight, childWidth, isContainBorder, }) => {
    const isSingleImage = images.length === 1;
    if (isSingleImage)
        return (react.createElement(Image, { src: images.shift(), height: height || 80, width: width || 80, alt: "product" }));
    const remainImage = images.length - IMAGE_LIMIT;
    return (react.createElement(ComboImageWrapper, { width: width, height: height },
        images.slice(0, IMAGE_LIMIT).map((image, index) => (react.createElement(ChildImage, { width: childWidth, height: childHeight, isContainBorder: isContainBorder, src: image, alt: alt[index], key: keys[index] || index }))),
        remainImage > 0 && react.createElement(RemainingNumber, null,
            "+",
            remainImage + 1)));
};
const ComboImageWrapper = emotion_styled_browser_esm/* default.div */.Z.div((props) => ({
    width: props.width ? `${props.width}px` : '80px',
    height: props.height ? `${props.height}px` : '80px',
    background: '#F8F8FC',
    borderRadius: '4px',
    position: 'relative',
    cursor: 'pointer',
}));
const ChildImage = emotion_styled_browser_esm/* default.img */.Z.img((props) => ({
    borderRadius: '4px',
    width: props.width ? `${props.width}px` : '34px',
    height: props.height ? `${props.height}px` : '34px',
    margin: '4px 0 0 4px',
    border: props.isContainBorder ? 'solid 1px #E4E5F0' : 'unset',
}));
const RemainingNumber = emotion_styled_browser_esm/* default.div */.Z.div `
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: rgba(27, 29, 41, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  border: 4px;
  right: 4px;
  bottom: 4px;
`;
const Image = (0,emotion_styled_browser_esm/* default */.Z)(EnhancedImage_es/* EnhancedImage */.N) `
  border: 1px solid #e4e5f0;
`;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Variants/Variants.es.js



const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  color: #848788;
  font-size: 0.875rem;
  display: flex;
  flex-wrap: wrap;
`;
const Variant = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
`;
const Variants = ({ variants = [], }) => (react.createElement(Wrapper, null, variants.map((variant, index) => (react.createElement(Variant, { key: index },
    react.createElement(index_es/* Caption */.YS, { level: 1, color: "textSecondary" },
        variant.name,
        ": ",
        variant.value),
    index !== variants.length - 1 && (react.createElement(index_es/* Caption */.YS, { margin: ['s0', 's8'], color: "#E4E5F0" }, "|")))))));



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Dropdown/DropdownContext.es.js


const initialState = {
    referenceElement: null,
    toggle: () => { },
    isOpen: false,
    toggleType: '',
};
const DropdownContext = react.createContext(initialState);
const DropdownProvider = ({ children, value }) => {
    const [state, dispatch] = (0,react.useReducer)((state = initialState, action) => {
        switch (action.type) {
            case 'SET_REFERENCE':
                return Object.assign(Object.assign({}, state), { referenceElement: action.payload });
            default:
                return state;
        }
    }, initialState);
    return (react.createElement(DropdownContext.Provider, { value: { state: Object.assign(Object.assign({}, state), value), dispatch } }, children));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Dropdown/DropdownToggle.es.js




const DropdownToggle = ({ children, className, }) => {
    const [anchor, setAnchor] = (0,react.useState)(null);
    const { state: { toggle, toggleType }, dispatch, } = (0,react.useContext)(DropdownContext);
    (0,react.useEffect)(() => {
        dispatch({ type: 'SET_REFERENCE', payload: anchor });
    }, [anchor]);
    return (react.createElement(StyledDiv, { className: className, ref: setAnchor, onClick: toggleType === 'click' ? toggle : null, onKeyUp: toggleType === 'click' ? toggle : null, tabIndex: 0 }, children));
};
const StyledDiv = emotion_styled_browser_esm/* default.div */.Z.div `
  width: 100%;
  &:focus {
    outline: none;
  }
`;



// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.3.1-0e21e18015-de17a98d46.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(91806);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-popper-virtual-75fb226547/0/cache/react-popper-npm-2.2.5-6e86e4bf1e-915fcf08e1.zip/node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(71316);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Popper/Popper.es.js





const Container = emotion_styled_browser_esm/* default.div */.Z.div `
  [data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }
`;
const Popper = (_a) => {
    var { children, referenceElement, className, placement } = _a, _b = _a.popperConfig, _c = _b === void 0 ? {} : _b, { modifiers = [] } = _c, rest = (0,tslib_es6/* __rest */._T)(_c, ["modifiers"]);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles, attributes, update } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, Object.assign({ placement, modifiers: [
            {
                name: 'arrow',
                options: { element: arrowElement },
            },
            {
                name: 'flip',
                enabled: true,
            },
            { name: 'hide' },
            ...modifiers,
        ] }, rest));
    (0,react.useEffect)(() => {
        if (update) {
            update();
        }
    }, [className]);
    return (react.createElement(Container, Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { className: className }),
        children,
        react.createElement("div", { ref: setArrowElement, style: styles.arrow })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Dropdown/DropdownMenu.es.js





const DropdownMenu_es_StyledDiv = emotion_styled_browser_esm/* default.div */.Z.div(({ show }) => `
    background-color: transparent;
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = (0,emotion_styled_browser_esm/* default */.Z)(Popper)(({ show }) => `
    visibility: ${show ? 'visible' : 'hidden'};
    z-index: 999;
  `);
const DropdownMenu = ({ children, popperConfig, placement = 'bottom-start', origin = 'center top', className, }) => {
    const { state: { isOpen, referenceElement }, } = (0,react.useContext)(DropdownContext);
    return (react.createElement(StyledPopper, { className: className, referenceElement: referenceElement, popperConfig: popperConfig, placement: placement, show: isOpen },
        react.createElement(DropdownMenu_es_StyledDiv, { show: isOpen, origin: origin }, children)));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Dropdown/Dropdown.es.js





const Dropdown = (_a) => {
    var { children, isOpen, toggle, toggleType = 'click', className, onHide } = _a, props = (0,tslib_es6/* __rest */._T)(_a, ["children", "isOpen", "toggle", "toggleType", "className", "onHide"]);
    const wrapperRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        if (!isOpen) {
            return;
        }
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                toggle();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef, isOpen]);
    return (react.createElement(DropdownProvider, { value: { isOpen, toggle, toggleType } },
        react.createElement(DropdownWrapper, Object.assign({ onMouseEnter: toggleType === 'hover' ? toggle : null, onMouseLeave: toggleType === 'hover' ? onHide : null, className: className, ref: wrapperRef }, props), children)));
};
const DropdownWrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  width: 100%;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/Gift/Gift.es.js
var Gift_es = __webpack_require__(175);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/ProductInfo/ProductInfo.es.js












const ProductInfo = ({ product: { sku, imageUrl, name, variants = [], combos = [], link, childItems = [], tags = [], }, className, }) => {
    const [comboOpen, setComboOpen] = (0,react.useState)(false);
    const isCombo = childItems.length > 0;
    const toggleCombo = () => {
        setComboOpen((prev) => !prev);
    };
    const image = isCombo ? (react.createElement(ComboImage, { images: (0,helpers_index_es/* getComboImageUrl */.B1)(childItems) })) : (react.createElement(ProductInfo_es_Image, { height: 80, width: 80, src: imageUrl, alt: "product" }));
    const productName = isCombo ? (0,helpers_index_es/* getComboName */.AK)(childItems) : name;
    return (react.createElement(ProductInfo_es_Wrapper, { className: className },
        react.createElement(CustomLink_es/* CustomLink */.x, Object.assign({}, link), image),
        react.createElement(Right, null,
            react.createElement(CustomLink_es/* CustomLink */.x, Object.assign({}, link),
                react.createElement(index_es/* Body */.uT, { hoverColor: "primary500", level: 1, color: "textPrimary", weight: "regular", line: 2 },
                    tags && tags.length > 0 && (react.createElement(react.Fragment, null,
                        react.createElement(Tag_es/* Tag */.V, { type: "secondary", variant: "branding", content: tags[0] }),
                        "\u00A0")),
                    productName)),
            sku && (react.createElement(index_es/* Caption */.YS, { level: 1, color: "textSecondary" },
                "SKU: ",
                sku)),
            !!variants.length && react.createElement(Variants, { variants: variants }),
            !!combos.length && (react.createElement(StyledDropdown, { isOpen: comboOpen, toggle: toggleCombo, toggleType: "hover" },
                react.createElement(DropdownToggle, { toggleType: "hover" },
                    react.createElement(Action, { mgl: false }, "Xem combo")),
                react.createElement(DropdownMenu, { popperConfig: popperConfig, origin: "left top" },
                    react.createElement(ComboList, null, combos.map(({ imageUrl, name }, index) => (react.createElement(StyledGift, { key: index, image: {
                            src: imageUrl,
                        }, text: name }))))))))));
};
const ProductInfo_es_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  gap: 12px;
`;
const Right = emotion_styled_browser_esm/* default.div */.Z.div `
  flex: 1;
`;
const Action = emotion_styled_browser_esm/* default.span */.Z.span(({ mgl = true }) => `
      font-size: 14px;
      color: #047fff;
      margin-left: ${mgl ? '1.5rem' : 0};
      cursor: pointer;
      display: inline-block;
      width: max-content;
      flex-shrink: 0;
    `);
const ComboList = emotion_styled_browser_esm/* default.ul */.Z.ul `
  padding: 0.25rem 0.75rem;
  list-style-type: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 0.5rem 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  background-color: white;
  margin: 0;
  width: max-content;
  max-width: 25rem;
`;
const StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown) `
  width: max-content;
`;
const popperConfig = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [0, 10],
            },
        },
    ],
};
const StyledGift = (0,emotion_styled_browser_esm/* default */.Z)(Gift_es/* Gift */.n) `
  margin: 0.5rem 0;
`;
const ProductInfo_es_Image = (0,emotion_styled_browser_esm/* default */.Z)(EnhancedImage_es/* EnhancedImage */.N) `
  border: 1px solid #e4e5f0;
`;




/***/ }),

/***/ 34294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProductPriceCart; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(40415);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(64802);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/helpers/IconBase.es.js + 1 modules
var IconBase_es = __webpack_require__(80711);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/EditOutlined.es.js


const EditOutlined = (props) => {
    return (0,IconBase_es/* GenIcon */.w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M14.4798 5.35373C14.968 4.86557 15.7594 4.86557 16.2476 5.35373L16.6919 5.79803C17.1801 6.28618 17.1801 7.07764 16.6919 7.56579L16.1819 8.07582L13.9698 5.86375L14.4798 5.35373ZM12.9092 6.92441L6.23644 13.5971L5.68342 16.3622L8.44851 15.8092L15.1212 9.13648L12.9092 6.92441ZM16.707 9.67199L9.3486 17.0304C9.24389 17.1351 9.11055 17.2065 8.96535 17.2355L4.87444 18.0537C4.62855 18.1029 4.37434 18.0259 4.19703 17.8486C4.01971 17.6713 3.94274 17.4171 3.99192 17.1712L4.8101 13.0803C4.83914 12.9351 4.91051 12.8017 5.01521 12.697L13.4192 4.29307C14.4931 3.21912 16.2343 3.21912 17.3083 4.29307L17.7526 4.73737C18.8265 5.81131 18.8265 7.55251 17.7526 8.62645L16.7174 9.66162C16.7157 9.66336 16.714 9.6651 16.7122 9.66683C16.7105 9.66856 16.7088 9.67028 16.707 9.67199ZM3.15918 20.5908C3.15918 20.1766 3.49497 19.8408 3.90918 19.8408H20.2728C20.687 19.8408 21.0228 20.1766 21.0228 20.5908C21.0228 21.005 20.687 21.3408 20.2728 21.3408H3.90918C3.49497 21.3408 3.15918 21.005 3.15918 20.5908Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};



// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(16251);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/Common/ProductPriceCart/ProductPriceCart.es.js






const ProductPriceCart = ({ supplierRetailPrice, latestPrice, isPriceEditable, onEditPrice, className, align, isMobile = true, }) => {
    return (react.createElement("div", null,
        react.createElement(Wrapper, { className: className },
            react.createElement(ProductPrice_es/* ProductPrice */.j, { supplierRetailPrice: supplierRetailPrice, latestPrice: latestPrice, textColor: "textPrimary", align: align }),
            isPriceEditable && isMobile && (react.createElement(StyledEditIcon, { onClick: onEditPrice, size: "1.25rem" }))),
        isPriceEditable && !isMobile && (react.createElement(EditPriceWrapper, null,
            react.createElement(StyledButtonChangePrice, { level: 1, color: "link500", hoverColor: "error500", onClick: onEditPrice }, (0,i18n_es.t)('Sửa giá'))))));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
`;
const StyledEditIcon = (0,emotion_styled_browser_esm/* default */.Z)(EditOutlined) `
  margin-left: 4px;
`;
const StyledButtonChangePrice = (0,emotion_styled_browser_esm/* default */.Z)(index_es/* Body */.uT) `
  margin-top: 4px;
  cursor: pointer;
`;
const EditPriceWrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  justify-content: flex-end;
  display: flex;
  line-height: 20px;
`;




/***/ }),

/***/ 89755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Voucher; }
/* harmony export */ });
var img = "data:image/svg+xml,%3csvg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='64' height='64' rx='4' fill='%23FFF5F6'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M44 28.6666C44 29.2186 43.552 29.6666 43 29.6666C41.86 29.6666 41 30.5266 41 31.6666C41 32.8066 41.86 33.6666 43 33.6666C43.552 33.6666 44 34.1146 44 34.6666V39.6666C44 40.2186 43.552 40.6666 43 40.6666H21C20.448 40.6666 20 40.2186 20 39.6666V34.6666C20 34.1146 20.448 33.6666 21 33.6666C22.14 33.6666 23 32.8066 23 31.6666C23 30.5266 22.14 29.6666 21 29.6666C20.448 29.6666 20 29.2186 20 28.6666V23.6666C20 23.1146 20.448 22.6666 21 22.6666H43C43.552 22.6666 44 23.1146 44 23.6666V28.6666ZM30 28.1666C30 27.3386 29.328 26.6666 28.5 26.6666C27.672 26.6666 27 27.3386 27 28.1666C27 28.9946 27.672 29.6666 28.5 29.6666C29.328 29.6666 30 28.9946 30 28.1666ZM34 35.1666C34 35.9946 34.672 36.6666 35.5 36.6666C36.328 36.6666 37 35.9946 37 35.1666C37 34.3386 36.328 33.6666 35.5 33.6666C34.672 33.6666 34 34.3386 34 35.1666ZM28.707 36.3736C28.3166 36.764 27.6835 36.764 27.293 36.3736C26.9026 35.9831 26.9026 35.35 27.293 34.9596L35.293 26.9596C35.6835 26.5691 36.3166 26.5691 36.707 26.9596C37.0975 27.35 37.0975 27.9831 36.707 28.3736L28.707 36.3736Z' fill='%23F83142'/%3e%3c/svg%3e";
  var Voucher = img;




/***/ }),

/***/ 62010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rb": function() { return /* binding */ PromoItemType; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "cC": function() { return /* binding */ formatPriceFull; },
/* harmony export */   "rd": function() { return /* binding */ getBenefits; },
/* harmony export */   "FL": function() { return /* binding */ getBlockDescriptionForCartPromo; },
/* harmony export */   "B1": function() { return /* binding */ getComboImageUrl; },
/* harmony export */   "AK": function() { return /* binding */ getComboName; },
/* harmony export */   "hJ": function() { return /* binding */ getDateStringWithFormat; },
/* harmony export */   "oL": function() { return /* binding */ getDateStringsTimeRange; },
/* harmony export */   "YW": function() { return /* binding */ getPromotionProduct; },
/* harmony export */   "m8": function() { return /* binding */ getPromotionStatus; },
/* harmony export */   "_C": function() { return /* binding */ getVoucherBenefit; }
/* harmony export */ });
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57083);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73776);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40415);




const formatPrice = (price) => {
    return price ? price.toLocaleString('vi-VN') : price;
};
const formatPriceFull = (price) => {
    return price || price === 0
        ? price.toLocaleString('vi-VN', {
            style: 'currency',
            currency: 'VND',
        })
        : price;
};
const sortItems = (childItems) => {
    return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
    if (childItems.length === 0)
        return '';
    const primary = sortItems(childItems)[0];
    const comboLength = childItems.length;
    return comboLength === 1
        ? primary.name
        : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('{{PrimaryName}} và {{var0}} sản phẩm khác', {
            PrimaryName: primary.name,
            var0: comboLength - 1,
        });
};
const getComboImageUrl = (childItems) => {
    if (childItems.length === 0)
        return [];
    return sortItems(childItems).map((item) => { var _a, _b; return item.imageUrl || ((_b = (_a = item.product) === null || _a === void 0 ? void 0 : _a.productInfo) === null || _b === void 0 ? void 0 : _b.imageUrl); });
};
const getDateStringWithFormat = (dateString, format = 'HH:mm dd/MM/yyyy') => {
    try {
        return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(dateString), format);
    }
    catch (_a) {
        return '';
    }
};
const getDateStringsTimeRange = (startDateString, endDateString) => {
    let str = '';
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);
    if (startDate.getFullYear() !== endDate.getFullYear()) {
        str += `${getDateStringWithFormat(startDateString, 'dd/MM/yyyy')}`;
    }
    else {
        if (startDate.getMonth() !== endDate.getMonth()) {
            str += `${getDateStringWithFormat(startDateString, 'dd/MM')}`;
        }
        else {
            str += `${getDateStringWithFormat(startDateString, 'dd')}`;
        }
    }
    str += ` - ${getDateStringWithFormat(endDateString, 'dd/MM/yyyy')}`;
    return str;
};
const getBlockDescriptionForCartPromo = (promo, withTime = false) => {
    var _a, _b, _c;
    const condition = ((_a = promo === null || promo === void 0 ? void 0 : promo.basePromotion) === null || _a === void 0 ? void 0 : _a.condition) || (promo === null || promo === void 0 ? void 0 : promo.condition);
    if (!condition)
        return '';
    const { orderValueMin, orderValueMax } = condition;
    const minValue = formatPriceFull(orderValueMin);
    const maxValue = formatPriceFull(orderValueMax);
    const startedAt = (_b = promo === null || promo === void 0 ? void 0 : promo.basePromotion) === null || _b === void 0 ? void 0 : _b.startedAt;
    const endedAt = (_c = promo === null || promo === void 0 ? void 0 : promo.basePromotion) === null || _c === void 0 ? void 0 : _c.endedAt;
    let str = '';
    if (orderValueMin && orderValueMax) {
        str = `Áp dụng cho đơn hàng từ ${minValue} đến ${maxValue} `;
    }
    else if (orderValueMin) {
        str = `Áp dụng cho đơn hàng từ ${minValue} `;
    }
    else if (orderValueMax) {
        str = `Áp dụng cho đơn hàng tối đa ${maxValue} `;
    }
    else
        str = 'Áp dụng cho mọi đơn hàng';
    if (withTime) {
        str += ` . Áp dụng từ ${getDateStringsTimeRange(startedAt, endedAt)}`;
    }
    return str;
};
var PromoItemType;
(function (PromoItemType) {
    PromoItemType["GIFT"] = "gift";
    PromoItemType["DISCOUNT"] = "discount";
    PromoItemType["VOUCHER"] = "voucher";
})(PromoItemType || (PromoItemType = {}));
const getDiscountName = (discount) => {
    if (discount.flat) {
        return `Giảm ngay ${formatPriceFull(discount.flat)} vào giá trị đơn hàng`;
    }
    if (discount.percent) {
        const suffix = discount.maxAmountPerOrder
            ? ` (giảm tối đa trên đơn ${formatPriceFull(discount.maxAmountPerOrder)})`
            : '';
        return (`Giảm ngay ${discount.percent}% tối đa ${formatPriceFull(discount.maxAmount)}` + suffix);
    }
    return '';
};
const getVoucherName = (voucher) => {
    const defaultVoucherName = 'Tặng Voucher dùng cho đơn hàng sau';
    return !!voucher.name && !!voucher.quantity
        ? `${voucher.quantity} x ${voucher.name}`
        : defaultVoucherName;
};
const getGiftName = (gift) => {
    return `Quà tặng: ${gift.quantity} x ${gift.name} `;
};
const getBenefits = (benefit, withDiscount = true, condition) => {
    var _a;
    const results = [];
    if (benefit) {
        if (benefit.discount && withDiscount) {
            let flat = ((_a = benefit === null || benefit === void 0 ? void 0 : benefit.discount) === null || _a === void 0 ? void 0 : _a.flat) || 0;
            const blockSizeDecimal = condition === null || condition === void 0 ? void 0 : condition.blockSizeDecimal;
            if (blockSizeDecimal > 0 && blockSizeDecimal < 1) {
                flat = flat / blockSizeDecimal;
            }
            results.push({
                type: PromoItemType.DISCOUNT,
                text: getDiscountName(Object.assign(Object.assign({}, benefit.discount), { flat })),
            });
        }
        ((benefit === null || benefit === void 0 ? void 0 : benefit.gifts) || []).forEach((gift) => {
            const imgUrl = gift.imageUrl ? gift.imageUrl : '';
            results.push({
                type: PromoItemType.GIFT,
                text: getGiftName(gift),
                imgSrc: imgUrl,
            });
        });
        if (benefit.voucher) {
            results.push({
                type: PromoItemType.VOUCHER,
                text: getVoucherName(benefit.voucher),
            });
        }
    }
    return results;
};
const getPromotionProduct = (promotion) => {
    var _a, _b, _c, _d;
    const { benefit, condition } = promotion === null || promotion === void 0 ? void 0 : promotion.basePromotion;
    const gifts = promotion === null || promotion === void 0 ? void 0 : promotion.gifts;
    const results = [];
    if (benefit === null || benefit === void 0 ? void 0 : benefit.discount) {
        if ((_a = benefit === null || benefit === void 0 ? void 0 : benefit.discount) === null || _a === void 0 ? void 0 : _a.percent) {
            results.push({
                type: PromoItemType.DISCOUNT,
                text: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('Giảm {{percent}}% tối đa {{maxAmount}}', {
                    percent: (_b = benefit === null || benefit === void 0 ? void 0 : benefit.discount) === null || _b === void 0 ? void 0 : _b.percent,
                    maxAmount: formatPriceFull((_c = benefit === null || benefit === void 0 ? void 0 : benefit.discount) === null || _c === void 0 ? void 0 : _c.maxAmount),
                }),
            });
        }
        else {
            let flat = ((_d = benefit === null || benefit === void 0 ? void 0 : benefit.discount) === null || _d === void 0 ? void 0 : _d.flat) || 0;
            const blockSizeDecimal = condition === null || condition === void 0 ? void 0 : condition.blockSizeDecimal;
            if (blockSizeDecimal > 0 && blockSizeDecimal < 1) {
                flat = flat / blockSizeDecimal;
            }
            results.push({
                type: PromoItemType.DISCOUNT,
                text: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('Giảm tiền trực tiếp {{flat}}', {
                    flat: formatPriceFull(flat),
                }),
            });
        }
    }
    if (!!(gifts === null || gifts === void 0 ? void 0 : gifts.length)) {
        gifts === null || gifts === void 0 ? void 0 : gifts.forEach((gift) => {
            results.push({
                type: PromoItemType.GIFT,
                text: `${(gift === null || gift === void 0 ? void 0 : gift.quantityDecimal) || 0}x ${(gift === null || gift === void 0 ? void 0 : gift.name) || ''}`,
            });
        });
    }
    if (!!(benefit === null || benefit === void 0 ? void 0 : benefit.voucher)) {
        results.push({
            type: PromoItemType.VOUCHER,
            text: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('{{quantity}}x {{name}} Mã giảm giá cho đơn hàng sau', {
                quantity: benefit.voucher.quantity,
                name: benefit.voucher.name,
            }),
        });
    }
    return results;
};
const getVoucherBenefit = (maxAmount, percent, flat, orderValueMin, orderValueMax, applyOn) => {
    let benefit = '';
    if (flat) {
        benefit += `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('Giảm')} ${formatPriceFull(flat)}`;
    }
    else if (percent) {
        benefit += `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('Giảm')} ${percent}%`;
        if (maxAmount) {
            benefit += ` ${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('tối đa {{maxAmount}}', {
                maxAmount: formatPriceFull(maxAmount),
            })}`;
        }
    }
    else {
        benefit += 'Dành';
    }
    if (orderValueMin && orderValueMax) {
        benefit += ` ${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('cho đơn hàng từ {{min}} đến {{max}}', {
            min: formatPriceFull(orderValueMin),
            max: formatPriceFull(orderValueMax),
        })}`;
    }
    else if (orderValueMin) {
        benefit += ` ${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('cho đơn hàng tối thiểu {{min}}', {
            min: formatPriceFull(orderValueMin),
        })}`;
    }
    else if (orderValueMax) {
        benefit += ` ${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('cho đơn hàng dưới {{max}}', {
            max: formatPriceFull(orderValueMax),
        })}`;
    }
    else {
        benefit += ` ${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('cho tất cả các đơn hàng')}`;
    }
    if (applyOn === 'part_order') {
        benefit += ` (${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)('Chỉ áp dụng trên một số sản phẩm')})`;
    }
    return benefit;
};
const getPromotionStatus = (cartPromotionId, isSelectable) => {
    if (cartPromotionId === null && isSelectable) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
    }
    else if (cartPromotionId === null && !isSelectable) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .PromotionStatus.DISABLED */ .d.DISABLED;
    }
    else if (cartPromotionId !== null && isSelectable) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .PromotionStatus.SELECTED */ .d.SELECTED;
    }
    else {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .PromotionStatus.FIXED */ .d.FIXED;
    }
};




/***/ }),

/***/ 40415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(96556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/vi.es.js
var viLang = {
	
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/en.es.js
var enLang = {
	"Được phép nâng giá bán tối đa": "Max raised price allowed",
	"Giá muốn bán không được vượt quá {{var0}}": "Selling price cannot exceed {{var0}}",
	"Giá muốn bán không được nhỏ hơn giá sản phẩm": "Selling price cannot be less than supplier price",
	"Giá sản phẩm": "Supplier price",
	"Giá muốn bán": "Selling price",
	"Nhập số tiền": "Input amount",
	"Số tiền chênh:": "Gap amount:",
	"Sửa giá": "Edit price",
	"Dùng sau": "Use later",
	"Áp dụng": "Apply",
	"Bỏ chọn": "Unselect",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Bạn chỉ có thể mua tối đa {{maximumValue}} sản phẩm": "You can only purchase max {{maximumValue}} products",
	"Chú ý": "Note",
	"Bạn muốn xoá sản phẩm này ra khỏi giỏ hàng?": "Are your sure to delete product from Cart?",
	"Đồng ý": "Agree",
	"Hủy bỏ": "Cancel",
	"Xóa": "Delete",
	"x{{ProductVoucherQuantity}} Voucher dùng cho đơn hàng sau": "x{{ProductVoucherQuantity}} Voucher used for next order",
	"Không bán chịu": "Not selling on credit",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Chỉ áp dụng trên một số sản phẩm": "Applicable for some specific products only",
	"Giảm": "Discount",
	"tối đa {{maxAmount}}": "max {{maxAmount}}",
	"Dành": "Applicable",
	"cho đơn hàng từ {{min}} đến {{max}}": "for the order from {{min}} to {{max}}",
	"cho đơn hàng tối thiểu {{min}}": "for the order from {{min}}",
	"cho đơn hàng dưới {{max}}": "for the order under {{max}}",
	"cho tất cả các đơn hàng": "for all orders",
	"Giảm {{percent}}% tối đa {{maxAmount}}": "{{percent}}% off up to {{maxAmount}}",
	"{{quantity}}x {{name}} Mã giảm giá cho đơn hàng sau": "{{quantity}}x {{name}} Discount code for next order",
	"Thành tiền": "Total",
	"Đơn giá": "Unit price",
	"Số lượng": "Quantity",
	"Khuyến mại hot": "Promotions hot",
	"HSD:": "Expiry date:",
	"Chương trình khuyến mại": "Promotions",
	"Sản phẩm ưu đãi": "Promotional products",
	"Tìm kiếm chương trình khuyến mại": "Search promotions",
	"Tìm kiếm sản phẩm khuyến mại": "Search promotional products",
	"Không tìm thấy chương trình nào.": "No program found.",
	"Không tìm thấy sản phẩm nào.": "No product found.",
	"Lỗi": "Error"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/i18n.es.js




const NAMESPACE = 'ui-cart';
const t = (keys, options) => {
    const text = i18next/* default.t */.Z.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
    return text || keys;
};
const lang = {
    vi: viLang,
    en: enLang,
};




/***/ }),

/***/ 73776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PromotionStatus; }
/* harmony export */ });
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus[PromotionStatus["SELECTED"] = 0] = "SELECTED";
    PromotionStatus[PromotionStatus["UNSELECTED"] = 1] = "UNSELECTED";
    PromotionStatus[PromotionStatus["DISABLED"] = 2] = "DISABLED";
    PromotionStatus[PromotionStatus["FIXED"] = 3] = "FIXED";
})(PromotionStatus || (PromotionStatus = {}));




/***/ }),

/***/ 67085:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);